
export default remConfig => {
  var deviceWidth = document.documentElement.clientWidth // 获取可视屏幕宽度
  if (deviceWidth > 640) { // 若移动端配置宽度750以下，统一按照750进行计算
    // deviceWidth = 640
    document.documentElement.style.fontSize = 9 * (1 + ((deviceWidth - 640) / 640)) + 'px' // 设置fontSize为7.5设备宽度大小
  }
  window.onresize = function () {
    remConfig() // 当窗口发生变化重新调用remConfig
    // 此步骤可省略，因为移动端一般没有设备大小，便于在chrome调试
  }
}



//////////////////
// WEBPACK FOOTER
// ./static/remConfig.js
// module id = null
// module chunks = 